(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["body-pillow-size-selector"] && !Shopify.designMode) return;
  try {
    class PillowSizeSelector extends HTMLElement {
    constructor() {
      super();
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    connectedCallback() {
      this.cta = this.querySelector('.body-pillow-configuration--cta');
      this.sizeSelector = this.querySelector('.body-pillow-configuration--sizes');
      this.selectedSize = this.querySelector('.body-pillow-configuration--selected-size');
      this.sizePlaceholder = this.querySelector('.body-pillow-configuration--placeholder-copy');

      this.cta.addEventListener('click', this.toggleSizesContainer.bind(this));
      this.sizeSelector.addEventListener('input', this.sizeSelectorEventHandler.bind(this));
      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      this.cta.removeEventListener('click', this.toggleSizesContainer.bind(this));
      this.sizeSelector.removeEventListener('input', this.sizeSelectorEventHandler.bind(this));
      document.removeEventListener('click', this.handleDocumentClick);
    }

    toggleSizesContainer() {
      this.sizeSelector.classList.toggle('hidden');
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target) && !this.sizeSelector.classList.contains('hidden')) {
        this.sizeSelector.classList.add('dawn-hidden');
      }
    }

    sizeSelectorEventHandler(event) {
      const input = event.target.closest('input');
      this.selectedSize.innerHTML = input.dataset.sizeDescription;
      this.sizePlaceholder.classList.add('dawn-hidden');
      this.toggleSizesContainer();
      this.dispatchSizeSelectorEvent(event);
    }

    dispatchSizeSelectorEvent(event) {
      const { sizeHandle } = event.target.dataset;
      const customEvent = new CustomEvent('PillowSize:change', {
        detail: {
          size: sizeHandle,
        },
      });
      document.dispatchEvent(customEvent);
    }

    resetElements() {
      this.sizePlaceholder.classList.remove('dawn-hidden');
      this.selectedSize.innerHTML = '';
    }
  }
  customElements.define('body-pillow-size-selector', PillowSizeSelector);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-body-pillow-configuration"] && !Shopify.designMode) return;
  try {
    class BodyPillowConfiguration extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartCountBubble = document.querySelector('#cart-icon-bubble');
    }

    connectedCallback() {
      this.sizeSelector = this.querySelector('body-pillow-size-selector');
      this.sizeError = this.querySelector('#main-product-pillow-configuration--size-error');
      this.addToCartBtn = this.querySelector('#main-product-pillow-configuration--add-to-cart');

      this.addToCartBtn.addEventListener('click', this.addToCartEventHandler.bind(this));
      this.sizeSelector.addEventListener('input', () => {
        this.toggleErrorSize(false);
      });
    }

    disconnectedCallback() {
      this.addToCartBtn.removeEventListener('click', this.addToCartEventHandler.bind(this));
      this.sizeSelector.removeEventListener('input', () => {
        this.toggleErrorSize(false);
      });
    }

    addToCartEventHandler() {
      const productId = this.sizeSelector.querySelector(`input[type="radio"]:checked`)?.value;
      if (!productId) {
        this.toggleErrorSize(true);
        return;
      }
      const cartData = {
        items: [
          {
            id: productId,
            quantity: 1,
          },
        ],
      };
      this.addToCart(cartData);
    }

    toggleErrorSize(flag = false) {
      if (flag) {
        this.addToCartBtn.disabled = true;
        this.sizeError.classList.remove('dawn-hidden');
        return;
      }
      this.addToCartBtn.disabled = false;
      this.sizeError.classList.add('dawn-hidden');
    }

    async addToCart(cartData) {
      this.setLoadingToAddToCart(true);
      try {
        const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(cartData),
        });
        const data = await addResponse.json();
        if (!addResponse.ok) throw new Error(`${data.description}`);
        if (window._learnq) {
          window._learnq.push(['track', 'Added to Cart', variant]);
        }
      } catch (error) {
        console.log(`${error}`);
      } finally {
        this.setLoadingToAddToCart(false);
        this.openAndPopulateCart();
        this.sizeSelector.resetElements();
      }
    }

    setLoadingToAddToCart(flag) {
      this.addToCartBtn.disabled = flag;
    }

    async openAndPopulateCart() {
      // Fetch the updated cart drawer content from the server
      const response = await fetch('/cart');
      const responseText = await response.text();

      // Parse the fetched HTML response into a DOM document
      const newCartMarkup = new DOMParser().parseFromString(responseText, 'text/html');

      // Update cart icon bubble
      const newCartIconBubbleMarkup = newCartMarkup.querySelector('#cart-icon-bubble');
      this.cartCountBubble.innerHTML = newCartIconBubbleMarkup.innerHTML;

      // Remove empty class
      this.cartDrawer.classList.remove('is-empty');

      // Get new cart drawer markup
      const newCartDrawerMarkup = newCartMarkup.querySelector('#CartDrawer');

      // Replace markup
      this.cartDrawer.querySelector('#CartDrawer').replaceWith(newCartDrawerMarkup);

      // Open cart
      this.cartDrawer.open();

      this.cartDrawer.hideInstallmentsCTA();
    }
  }
  customElements.define('main-product-body-pillow-configuration', BodyPillowConfiguration);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["metaobject-case-swatches"] && !Shopify.designMode) return;
  try {
    class CaseSwatch extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cardMediaImg = this.closest('.card-wrapper.product-card-wrapper').querySelector('.media img');
      this.linkElements = this.closest('.card-wrapper.product-card-wrapper').querySelectorAll('a');
      this.addEventListener('click', this.mouseoverEventHandler.bind(this));
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.mouseoverEventHandler.bind(this));
    }

    mouseoverEventHandler(event) {
      const item = event.target.closest('.metaobject-swatches--item');
      if (!item) return;
      const { productFeatureImg, productHref } = item.dataset;
      this.cardMediaImg.setAttribute('src', productFeatureImg);
      this.cardMediaImg.setAttribute('srcset', productFeatureImg);
      this.linkElements.forEach((e) => e.setAttribute('href', productHref));
    }
  }
  customElements.define('metaobject-swatches', CaseSwatch);
  } catch(e) { console.error(e); }
})();

})();
